import React, { useState, useEffect } from 'react';
import { Trans, withTranslation } from 'react-i18next';

import { withStyles } from '@material-ui/styles';
import { Grid, Tooltip, Card } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import CButton from '../Utils/CButton';
import CInput from '../Utils/CInput';
import UserChangePasswordPageLoader from '../Utils/PageLoader';

import styles from '../../assets/jss/FormStyle';
import { EncryptionServices } from '../../services';
import { CheckIfPasswordIsValid } from '../../helper/StringUtils';

import '../../App.css';
import GridContainer from '../../assets/jss/GridContainer';

function UserChangePasswordForm(props) {
  const {
    classes,
    handleSubmit,
    isLoading,
    handleClose,
  } = props;

  const [error, setError] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
    iterationCount: false,
  });

  const [errorCheck, setErrorCheck] = useState({
    oldPassword: true,
    newPassword: true,
    confirmPassword: true,
    iterationCount: true,
  });

  const [errorMsg, setErrorMsg] = useState({
    oldPassword: 'VALIDATION.REQ_FIELD',
    newPassword: 'VALIDATION.REQ_FIELD',
    confirmPassword: 'VALIDATION.REQ_FIELD',
    iterationCount: 'VALIDATION.REQ_FIELD',
    oldIterationCount: 'VALIDATION.REQ_FIELD',
  });

  const [errorCount, setErrorCount] = useState(4);
  const [newPasswordIsValid, setNewPasswordIsValid] = useState(true);
  const [checkPassword, setCheckPassword] = useState(null);

  const loginUser = sessionStorage.getItem('cred') ? JSON.parse(sessionStorage.getItem('cred')).userData : false;

  useEffect(() => {
    const err = { ...errorCheck };
    let newErrCount = 0;
    Object.keys(err).forEach((key) => {
      if (err[key]) {
        newErrCount += 1;
      }
    });
    setErrorCount(newErrCount);
  }, [errorCheck]);

  function handleFormSubmit(e) {
    e.preventDefault();
    const oldPassword = e.target.oldPassword.value;
    const newPassword = e.target.newPassword.value;
    const confirmPassword = e.target.confirmPassword.value;
    const iterationCount = e.target.iterationCount.value;
    const oldIterationCount = e.target.oldIterationCount.value;

    const data = {};

    EncryptionServices.generateCredential(loginUser.email, oldPassword, oldIterationCount).then(
      (credentials) => {
        data.oldPassword = credentials.password;
      },
    );

    EncryptionServices.generateCredential(loginUser.email, newPassword, iterationCount).then(
      (credentials) => {
        data.newPassword = credentials.password;
      },
    );
    EncryptionServices.generateCredential(loginUser.email, confirmPassword, iterationCount).then(
      (credentials) => {
        data.confirmPassword = credentials.password;
        data.iterationCount = iterationCount;
        handleSubmit(data);
      },
    );
  }

  function checkError(domElement, boolean, errMsg = null) {
    const err = { ...error };
    const errCheck = { ...errorCheck };

    let isError = boolean;
    let errorMessage = errMsg;

    if (domElement.name === 'confirmPassword') {
      setCheckPassword(domElement.value);
      err.newPassword = false;
      errCheck.newPassword = false;
    }

    if (!boolean && domElement.name === 'newPassword') {
      setNewPasswordIsValid(false);
    } else if (boolean && domElement.name === 'newPassword') {
      setNewPasswordIsValid(true);
    }

    if (!boolean && domElement.name === 'newPassword' && checkPassword) {
      if (CheckIfPasswordIsValid(domElement.value, checkPassword)) {
        isError = false;
      } else if (domElement.name === 'confirmPassword' && boolean) {
        err.newPassword = false;
        errCheck.newPassword = false;
      } else {
        isError = true;
        errorMessage = <Trans>VALIDATION.NEW_CONFIRM_PASS</Trans>;
      }
    }

    const checkErrorNewErrorMsg = { ...errorMsg };

    err[domElement.name] = isError;
    errCheck[domElement.name] = isError;

    if (errorMessage) {
      checkErrorNewErrorMsg[domElement.name] = errorMessage;
      setErrorMsg(checkErrorNewErrorMsg);
    }

    setError(err);
    setErrorCheck(errCheck);
  }

  return (
    <form
      name="userChangePasswordForm"
      onSubmit={handleFormSubmit}
      className={`${classes.headerBar} ${classes.createHeaderBarModal}`}
    >

      <UserChangePasswordPageLoader isLoading={isLoading} />

      <div className={`${classes.paddingTwoFive} ${classes.createHeaderBarModal}`}>
        <Card className={`${classes.overflowVisible} ${classes.createHeaderBarModal}`}>
          <Grid item xs={12}>

            <GridContainer>
              <div className={classes.freezeFooter}>

                <Grid item xs={12} sm={12} md={12} className={classes.marginBottomSpacing}>
                  <CInput
                    name="oldPassword"
                    label={(
                      <>
                        <Trans>LOGIN.OPASS</Trans>
                        *
                      </>
                    )}
                    validateForm
                    isError={error.oldPassword}
                    checkError={checkError}
                    errorVal={errorMsg.oldPassword}
                  />
                  <Tooltip
                    title={(<Trans>VALIDATION.OLD_PASSWORD_HELP</Trans>)}
                    classes={{ tooltip: classes.tooltipClass }}
                  >
                    <HelpOutlineIcon className={classes.helpIcon} />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className={classes.marginBottomSpacing}>
                  <CInput
                    name="oldIterationCount"
                    label={(
                      <>
                        <Trans>LOGIN.OITC</Trans>
                        *
                      </>
                    )}
                    validateForm
                    isError={error.oldIterationCount}
                    errorVal={errorMsg.oldIterationCount}
                    checkError={checkError}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} className={classes.marginBottomSpacing}>
                  <CInput
                    name="newPassword"
                    label={(
                      <>
                        <Trans>LOGIN.NPASS</Trans>
                        *
                      </>
                    )}
                    validateForm
                    isError={error.newPassword}
                    errorVal={errorMsg.newPassword}
                    checkError={checkError}
                  />
                  <Tooltip
                    title={(<Trans>VALIDATION.NEW_PASSWORD_HELP</Trans>)}
                    classes={{ tooltip: classes.tooltipClass }}
                  >
                    <HelpOutlineIcon className={classes.helpIcon} />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className={classes.marginBottomSpacing}>

                  <CInput
                    name="confirmPassword"
                    label={(
                      <>
                        <Trans>LOGIN.CPASS</Trans>
                        *
                      </>
                    )}
                    validateForm
                    isError={error.confirmPassword}
                    errorVal={errorMsg.confirmPassword}
                    checkError={checkError}
                    readonly={newPasswordIsValid}
                    helperText={(newPasswordIsValid && !error.confirmPassword)
                      ? <Trans>VALIDATION.ENABLE_C_PASS</Trans> : null}
                  />

                  <Tooltip
                    title={(<Trans>VALIDATION.CONFIRM_PASSWORD_HELP</Trans>)}
                    classes={{ tooltip: classes.tooltipClass }}
                  >
                    <HelpOutlineIcon className={classes.helpIcon} />
                  </Tooltip>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className={classes.marginBottomSpacing}>
                  <CInput
                    name="iterationCount"
                    label={(
                      <>
                        <Trans>LOGIN.NITC</Trans>
                        *
                      </>
                    )}
                    validateForm
                    isError={error.iterationCount}
                    errorVal={errorMsg.iterationCount}
                    checkError={checkError}
                  />
                </Grid>

              </div>
            </GridContainer>

          </Grid>

          <CButton
            type="BUTTON.SUBMIT"
            onCancel={handleClose}
            disabled={errorCount > 0}
            isFull
          />
        </Card>
      </div>
    </form>
  );
}

export default (withTranslation()(withStyles(styles, { withTheme: true })(UserChangePasswordForm)));
